import React from "react";

const NewsLetterArea = () => {
  const handleSubmit = () => {
    alert("Thanks for Subscribing Newsletter")
  }
  return (
    <section className="newsletter-area pt-110 pb-120">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-6">
            <div className="section-title text-center mb-80">
              <span className="sub-title">Get update</span>
              <h2 className="title">
                Get latest updates
              </h2>
            </div>
          </div>
        </div>
        
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="newsletter-form">
              <form action="#" onSubmit={handleSubmit}>
                <input type="email" placeholder="Enter your email address" />
                <button type="submit" className="btn">
                  Subscribe <span></span>
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div className="newsletter-shape-wrap">
        <img
          src="/img/images/newsletter_bg_shape.webp"
          alt="get-updates"
          className="bg-shape"
        />
        <img
          src="/img/images/newsletter_shape01.webp"
          alt="get-updates"
          className="shape-one"
        />
        <img
          src="/img/images/newsletter_shape02.webp"
          alt="get-updates"
          className="shape-two"
        />
        <img
          src="/img/images/newsletter_shape03.webp"
          alt="get-updates"
          className="shape-three"
        />
        <img
          src="/img/images/newsletter_shape04.webp"
          alt="get-updates"
          className="shape-four"
        />
        <img
          src="/img/images/newsletter_shape05.webp"
          alt="get-updates"
          className="shape-five"
        />
        <img
          src="/img/images/newsletter_shape06.webp"
          alt="get-updates"
          className="shape-six"
        />
      </div>
    </section>
  );
};

export default NewsLetterArea;
